import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { BehaviorSubject } from 'rxjs';

import { SystemSessionServiceProvider } from '../providers/servicer/system-session-service';
import { SystemSession } from '../providers/servicer/models/system-session';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = 'HomePage';

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public systemSessionService: SystemSessionServiceProvider
  ) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }

  get isLogin(): BehaviorSubject<SystemSession> {
    return this.systemSessionService.session$;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts